import "./index.css";

export const OpenAdminTabs = ({ name, icon, key, onClick }) => {
  return (
    <div className="open-admin-tabs" key={key} onClick={onClick}>
      <img
        src={icon}
        alt={`Admin dashboard ${name} tab`}
        width={35}
        height={35}
      />
      <p>{name}</p>
    </div>
  );
};
